import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { Icon } from '../../components/Icon';
import { SearchBar } from '../../components/SearchBar';
import { TypesButton } from '../../constants/ButtonTypes';
import { colors } from '../../constants/Colors';
import { routes } from '../../constants/RouterPath';
import { SizesButton } from '../../constants/SizeButton';
import { createLoadHoc } from '../../helpers/hocs/createLoadHoc';
import { selectGetFeedsLoader } from '../../selectors/feeds';
import { TypesIcon } from '../../types/TypesIcon';
import { FeedsTable } from './components/FeedsTable';
import {
    StyledButton, StyledFlexRow, StyledPageTitle, StyledSearchBarWrapper, StyledWrapper,
} from './styles';

export const FeedsContent: FC = () => {
    const history = useHistory();

    const onAdd = () => {
        history.push(routes.feeds_create);
    };

    return (
        <StyledWrapper>
            <StyledPageTitle>
                Фиды
            </StyledPageTitle>
            <StyledFlexRow>
                <StyledSearchBarWrapper>
                    <SearchBar />
                </StyledSearchBarWrapper>
                <StyledButton
                    typeButton={TypesButton.PRIMARY}
                    size={SizesButton.S}
                    onClick={onAdd}
                >
                    <Icon
                        type={TypesIcon.PLUS}
                        color={colors.white}
                        width="16px"
                        height="16px"
                        viewBox="0 0 16 16"
                    />
                    Добавить
                </StyledButton>
            </StyledFlexRow>
            <FeedsTable />
        </StyledWrapper>
    );
};

const loader = createLoadHoc({
    selectLoader: selectGetFeedsLoader,
});

export const FeedsContentWithLoader = loader(FeedsContent);
